// extracted by mini-css-extract-plugin
module.exports = {"form":"IHSHS0","message":"Sfkt9b","circle":"_3xWQJs","circle__check":"_3wtRD3"};